import { atom } from 'recoil';

/**
 * Atom for pending kboard result routing (queue-based).
 * When kboard sends results back, the routing logic pushes items into this queue
 * so that the correct ChatAI instance (matching targetThreadId) can
 * consume them sequentially using its own local setters.
 *
 * Each item in the queue:
 * @property {string} targetThreadId - The chatThreadId that should consume this result
 * @property {Object} payload - The raw kboard payload (to pass to handleDataFromKboard)
 * @property {Object} staticData - Captured context data (formList, fieldList, filterKnowledgeListData, etc.)
 */
export const kboardPendingResultAtom = atom({
    key: 'kboardPendingResultAtom',
    default: [],
});
